import { ColorOverflowIndicator } from '@/components/blocks/ProductCardSelectColor/ColorOverflowIndicator';
import { ProductColor } from '@/components/blocks/ProductCardSelectColor/ProductColor';
import {
	colorDotsOuterSX,
	colorDotsRowSX,
} from '@/components/blocks/ProductCardSelectColor/styles';
import { useVisibleColorVariants } from '@/components/blocks/ProductCardSelectColor/useVisibleColorVariants';
import { ProductType } from '@/data/types/Product';
import { Box, SxProps, Theme } from '@mui/material';
import { useMemo } from 'react';

export { ProductColor } from '@/components/blocks/ProductCardSelectColor/ProductColor';

interface Props {
	variants: ProductType[];
	selectedPartNumber: string;
	sx?: SxProps<Theme>;
	onSelectColor?: (item: ProductType) => void;
}

export const ProductCardSelectColor = ({
	variants,
	selectedPartNumber,
	sx,
	onSelectColor,
}: Props) => {
	const { containerRef, visibleCount, overflowCount, hasOverflow } = useVisibleColorVariants(
		variants.length
	);

	const visibleVariants = useMemo(
		() => variants.slice(0, visibleCount),
		[variants, visibleCount]
	);

	const handleSelectColor = (variant: ProductType) => (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		onSelectColor?.(variant);
	};

	return (
		<Box ref={containerRef} sx={colorDotsOuterSX(sx)}>
			{variants.length > 0 ? (
				<Box sx={colorDotsRowSX}>
					{visibleVariants.map((variant) => (
						<ProductColor
							key={variant.partNumber}
							variant={variant}
							isSelected={variant.partNumber === selectedPartNumber}
							onClick={handleSelectColor(variant)}
						/>
					))}
					{hasOverflow ? <ColorOverflowIndicator count={overflowCount} /> : null}
				</Box>
			) : null}
		</Box>
	);
};
